/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function encode(val) {
    return encodeURIComponent(val)
        .replace(/%3A/gi, ':')
        .replace(/%24/g, '$')
        .replace(/%2C/gi, ',')
        .replace(/%20/g, '+')
        .replace(/%5B/gi, '[')
        .replace(/%5D/gi, ']');
}
function isURLSearchParams(params) {
    return Object.prototype.toString.call(params).slice(8, -1) === 'URLSearchParams';
}
function buildURL(url, params) {
    if (!params) {
        return url;
    }
    let serializedParams = '';
    if (isURLSearchParams(params)) {
        serializedParams = params.toString();
    }
    else {
        const parts = [];
        Object.keys(params).forEach(key => {
            let val = params[key];
            if (val === null || typeof val === 'undefined') {
                return;
            }
            if (!Array.isArray(val)) {
                val = [val];
            }
            val.forEach(v => {
                if (v instanceof Date) {
                    v = v.toISOString();
                }
                else if (typeof v === 'object' && v !== null) {
                    v = JSON.stringify(v);
                }
                parts.push(`${encode(key)}=${encode(v)}`);
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) {
            url = url.slice(0, hashmarkIndex);
        }
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}
function parseHeaders(headers) {
    const parsed = {};
    let key;
    let val;
    let i;
    if (!headers) {
        return parsed;
    }
    headers.split('\n').forEach(line => {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (key) {
            if (key === 'set-cookie') {
                // @ts-ignore
                parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
            }
            else {
                parsed[key] = parsed[key] ? `${parsed[key]}, ${val}` : val;
            }
        }
    });
    return parsed;
}
// copy from axios
// remove authcancel download upload xsrf token paramsSerializer isFormData
function request(config) {
    let requestData = config.data;
    const requestHeaders = config.headers || {};
    const responseType = config.responseType || '';
    const { callback } = config;
    let request = new XMLHttpRequest();
    request.open(config.method.toUpperCase(), buildURL(config.url, config.params), true);
    // Set the request timeout in MS
    request.timeout = config.timeout || 10 * 1000;
    function onloadend() {
        if (!request) {
            return;
        }
        // Prepare the response
        const responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
        let responseData = request.response;
        if (!responseType || responseType === 'text' || responseType === 'json') {
            try {
                responseData = JSON.parse(request.responseText);
            }
            catch (error) {
                responseData = request.responseText;
            }
        }
        const response = {
            data: responseData,
            status: request.status,
            statusText: request.statusText,
            headers: responseHeaders,
            config,
            request,
        };
        if (response.status >= 200 && response.status < 300) {
            callback(null, response);
        }
        else {
            callback(new Error(`Request failed with status code ${response.status}`));
        }
        // Clean up request
        request = null;
    }
    if ('onloadend' in request) {
        // Use onloadend if available
        request.onloadend = onloadend;
    }
    else {
        // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
                return;
            }
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
                return;
            }
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
    }
    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
        if (!request) {
            return;
        }
        callback(new Error('Request aborted'));
        // Clean up request
        request = null;
    };
    // Handle low level network errors
    request.onerror = function handleError() {
        // Real errors are hidden from us by the browser
        // onerror should only fire if it's a network error
        callback(new Error('Network Error'));
        // Clean up request
        request = null;
    };
    // Handle timeout
    request.ontimeout = function handleTimeout() {
        const timeoutErrorMessage = config.timeout ? `timeout of ${config.timeout}ms exceeded` : 'timeout exceeded';
        callback(new Error(timeoutErrorMessage));
        // Clean up request
        request = null;
    };
    // Add headers to the request
    if ('setRequestHeader' in request) {
        Object.keys(requestHeaders).forEach(key => {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
                // Remove Content-Type if data is undefined
                // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete requestHeaders[key];
            }
            else {
                // Otherwise add header to the request
                request === null || request === void 0 ? void 0 : request.setRequestHeader(key, requestHeaders[key]);
            }
        });
    }
    // Add withCredentials to request if needed
    if (config.withCredentials !== undefined) {
        request.withCredentials = !!config.withCredentials;
    }
    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
        request.responseType = responseType;
    }
    if (!requestData) {
        requestData = null;
    }
    // Send the request
    request.send(requestData);
}

const converter = {
    read(value) {
        if (value[0] === '"') {
            value = value.slice(1, -1);
        }
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    },
};
function get(name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
        return;
    }
    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    const cookies = document.cookie ? document.cookie.split('; ') : [];
    const jar = {};
    for (const cookie of cookies) {
        const parts = cookie.split('=');
        const value = parts.slice(1).join('=');
        try {
            const found = decodeURIComponent(parts[0]);
            jar[found] = converter.read(value);
            if (name === found) {
                break;
            }
        }
        catch (e) { }
    }
    return jar[name];
}
function set(name, value, attr) {
    if (typeof document === 'undefined') {
        return;
    }
    const attributes = Object.assign({}, attr);
    attributes.path = attributes.path || '/';
    if (typeof attributes.expires === 'number') {
        // eslint-disable-next-line no-magic-numbers
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires instanceof Date) {
        attributes.expires = attributes.expires.toUTCString();
    }
    name = encodeURIComponent(name)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);
    let stringifiedAttributes = '';
    for (const attributeName in attributes) {
        if (!attributes[attributeName]) {
            continue;
        }
        stringifiedAttributes += `; ${attributeName}`;
        if (attributes[attributeName] === true) {
            continue;
        }
        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += `=${attributes[attributeName].split(';')[0]}`;
    }
    return (document.cookie = `${name}=${converter.write(value)}${stringifiedAttributes}`);
}
/**
 * 删除cookie
 * @param name 被删除的cookie值
 */
function remove(name) {
    set(name, '', { expires: -1 });
}

const URL = '/sn/source/sourceLeads/v2/leads/create';
function getUrl(env) {
    const domains = {
        test: '//test-source.gaotu100.com',
        prod: '//source.gaotu100.com',
    };
    if (env && domains[env]) {
        return domains[env] + URL;
    }
    const { hostname } = document.location;
    if (hostname.indexOf('test') > -1) {
        return domains.test + URL;
    }
    return domains.prod + URL;
}

function getOsFromUserAgent() {
    if (window === null || window === void 0 ? void 0 : window.navigator) {
        const deviceMatchRegexp = /(android|iphone\sos|mac\s[a-z|\s]+|windows)\s?(?:nt\s)?([\d_.]+)/;
        const { userAgent } = window.navigator;
        const userAgentLowerCase = userAgent.toLocaleLowerCase();
        const matched = userAgentLowerCase.match(deviceMatchRegexp);
        if (matched) {
            return [matched[1], matched[2]];
        }
        return [];
    }
    return [];
}
function executeInNextTick(callback) {
    if (typeof Promise !== 'undefined' && Promise.toString().indexOf('[native code]') !== -1) {
        Promise.resolve().then(callback);
    }
    else {
        setTimeout(callback);
    }
}

let configValue;
const readyQueue = [];
let readyQueueExecuteIndex = 0;
const resetReadyQueue = () => (readyQueueExecuteIndex = 0);
function callReadyFn(fn, leadsId) {
    try {
        fn(leadsId);
    }
    catch (error) {
        console.error(`source-sdk ready execute throw error: ${error}`);
    }
}
function triggleReadyQuene(leadsId) {
    configValue = leadsId;
    if (readyQueueExecuteIndex === 0) {
        for (; readyQueueExecuteIndex < readyQueue.length; ++readyQueueExecuteIndex) {
            callReadyFn(readyQueue[readyQueueExecuteIndex], leadsId);
        }
    }
}
let STORAGE_NAME = '_SOURCE_';
const SESSION_CACHE_KEY = 'temporary_leadsid';
let requestPending = false;
const DEFAULT_LEADS_ID = '';
const DEFAULT_RETRY_COUNT = 3;
let errorCallback;
let waitOnError = false;
let errorCallbackIsExecuted = false;
function onError(fn) {
    if (errorCallbackIsExecuted)
        return;
    errorCallback = fn;
    if (waitOnError && waitOnError instanceof Error) {
        errorCallback(waitOnError);
        errorCallbackIsExecuted = true;
    }
}
function triggerErrorCb(error) {
    if (errorCallbackIsExecuted)
        return;
    if (errorCallback) {
        try {
            errorCallback(error);
        }
        catch (error) {
            console.error(`source-sdk onError execute throw error: ${error}`);
        }
        errorCallbackIsExecuted = true;
    }
    else {
        waitOnError = error;
    }
}
/**
 * 清空缓存的leadsId，再次使用config会强制发起新的请求
 * @param sourceId 这个source下的leads被清除；
 *  如果不传，默认使用上一次`config`的source；
 *  如果没有调用过`config`，则不会处理
 */
function clearCache(sourceId) {
    if (!sourceId && STORAGE_NAME === '_SOURCE_') {
        console.warn('no sourceId! clear cache fail.');
        return;
    }
    if (STORAGE_NAME === '_SOURCE_') {
        remove(STORAGE_NAME + sourceId);
    }
    else {
        remove(STORAGE_NAME);
    }
    configValue = undefined;
    sessionStorage.clear();
    resetReadyQueue();
}
/**
 * 初始化生成LeadsId，若本地有缓存，不会再次发请求
 * @param param.sourceId 业务sourceId
 * @param param.env 运行环境 `test`/`prod`
 * @param requestConfig 请求参数
 * @returns void
 */
function config(_a, requestConfig) {
    var { sourceId, env, parentLeadsId } = _a, rest = __rest(_a, ["sourceId", "env", "parentLeadsId"]);
    if (requestPending)
        return;
    const { cacheInSession = false, force = false, retry = DEFAULT_RETRY_COUNT } = requestConfig || {};
    if (sourceId === undefined || sourceId === null) {
        if (cacheInSession) {
            const cacheValue = sessionStorage.getItem(SESSION_CACHE_KEY);
            if (cacheValue) {
                configValue = cacheValue;
                triggleReadyQuene(configValue);
                return;
            }
        }
        // 保证执行的是最后一个绑定的onError，在当前macro task下
        executeInNextTick(() => {
            triggerErrorCb(new Error('sourceId is undefined or null'));
        });
        triggleReadyQuene(DEFAULT_LEADS_ID);
        return;
    }
    if (STORAGE_NAME === '_SOURCE_')
        STORAGE_NAME += sourceId;
    if (parentLeadsId)
        STORAGE_NAME += `_${parentLeadsId}`;
    if (force) {
        clearCache();
    }
    const cookieValue = get(STORAGE_NAME);
    if (cookieValue) {
        configValue = cookieValue;
        triggleReadyQuene(configValue);
        return;
    }
    const [os, osVersion] = getOsFromUserAgent();
    requestPending = true;
    function doRequest(currentTryCount = 1) {
        request(Object.assign(Object.assign({ method: 'GET', url: getUrl(env), params: Object.assign({ source: sourceId, entrancePageUrl: location.href, parentLeadsId: parentLeadsId, 
                // 客户端类型默认 -1
                clientType: '-1', os,
                osVersion }, rest) }, requestConfig), { callback(error, res) {
                requestPending = false;
                if (error || !res) {
                    if (currentTryCount < retry) {
                        doRequest(++currentTryCount);
                        return;
                    }
                    triggerErrorCb(error ? error : new Error('No response data'));
                    triggleReadyQuene(DEFAULT_LEADS_ID);
                    return;
                }
                const { code, data, msg } = res.data;
                // eslint-disable-next-line no-magic-numbers
                if (code !== 200 || !data) {
                    if (currentTryCount < retry) {
                        doRequest(++currentTryCount);
                        return;
                    }
                    triggerErrorCb(new Error(msg || 'Service Error'));
                    triggleReadyQuene(DEFAULT_LEADS_ID);
                    return;
                }
                if (data.leadsId) {
                    const expires = new Date(new Date().setHours(23, 59, 59, 999).valueOf() + 1);
                    set(STORAGE_NAME, data.leadsId, { expires });
                    if (cacheInSession) {
                        sessionStorage.setItem(SESSION_CACHE_KEY, data.leadsId);
                    }
                }
                triggleReadyQuene(data.leadsId || DEFAULT_LEADS_ID);
            } }));
    }
    doRequest();
}
/**
 * 生成LeadsId成功后的回调
 * @param fn 回调函数
 * @returns void
 */
function ready(fn) {
    if (!fn)
        return;
    if (configValue !== undefined || configValue === DEFAULT_LEADS_ID) {
        callReadyFn(fn, configValue);
        readyQueueExecuteIndex++;
    }
    readyQueue.push(fn);
}
/**
 * 同步获取LeadsId，在确定本地有缓存的情况下使用
 *
 * 如果本地无缓存，返回`undefined`
 * @returns LeadsId
 */
function getValue() {
    return configValue !== null && configValue !== void 0 ? configValue : get(STORAGE_NAME);
}

export { clearCache, config, getValue, onError, ready };
